import React from 'react';

const Profile = () => (
  <div>Profile</div>
);

export default Profile;
